import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import submit from './submit';
import validate from './validate';
import { connect } from 'react-redux';

// Style
import cx from 'classnames';
import {
  Button,
  Row,
  FormGroup,
  Col,
  Tabs,
  Tab,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CancellationPolicyForm.css';
import cs from '../../../components/commonStyle.css';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import MultiLanguageInput from '../MultiLanguageInput';

class CancellationPolicyForm extends Component {

  static propTypes = {
    initialValues: PropTypes.object,
    policyType: PropTypes.string.isRequired,
    onPolicyChange: PropTypes.func.isRequired,
  };

  handleFieldChange = (fieldName, value) => {
    const { dispatch } = this.props;
    dispatch(change('CancellationPolicyForm', fieldName, value));
  };

  render() {
    const { error, handleSubmit, submitting, policyType, onPolicyChange, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.pagecontentWrapper)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.spaceBottom12)}>
              <FormattedMessage {...messages.cancellationPolicies} />
            </h1>

            {/* Policy Type Tabs */}
            <Tabs
              activeKey={policyType}
              onSelect={(key) => onPolicyChange(key)}
              id="cancellation-policy-tabs"
              className={cx(s.policyTabs, 'cancellationPolicyTabs')}
            >
              <Tab eventKey="Settings" title="⚙️ Settings" />
              <Tab eventKey="Flexible" title={formatMessage(messages.flexible)} />
              <Tab eventKey="Moderate" title={formatMessage(messages.moderate)} />
              <Tab eventKey="Strict" title={formatMessage(messages.strict)} />
              <Tab eventKey="Shared" title="Shared" />
            </Tabs>

            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}

              {/* Hidden field for policyType */}
              <Field name="policyType" component="input" type="hidden" />

              {/* Introduction Section */}
              <div className={cx(s.sectionBox, cs.spaceTop4)}>
                <h3 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.spaceBottom3)}>
                  <FormattedMessage {...messages.introductionText} />
                </h3>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 1
                  </label>
                  <MultiLanguageInput
                    baseField="contentOne"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 2
                  </label>
                  <MultiLanguageInput
                    baseField="contentTwo"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>
              </div>

              {/* Before Days Section */}
              <div className={cx(s.sectionBox, cs.spaceTop4)}>
                <h3 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.spaceBottom3)}>
                  <FormattedMessage {...messages.beforeDaysSection} />
                </h3>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.adminTitleLabel} />
                  </label>
                  <MultiLanguageInput
                    baseField="beforeDaysTitle"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="text"
                    placeholder={formatMessage(messages.title)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 1
                  </label>
                  <MultiLanguageInput
                    baseField="beforeDaysContentOne"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 2
                  </label>
                  <MultiLanguageInput
                    baseField="beforeDaysContentTwo"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>
              </div>

              {/* Check-In Section */}
              <div className={cx(s.sectionBox, cs.spaceTop4)}>
                <h3 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.spaceBottom3)}>
                  <FormattedMessage {...messages.checkInSection} />
                </h3>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.adminTitleLabel} />
                  </label>
                  <MultiLanguageInput
                    baseField="checkInTitle"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="text"
                    placeholder={formatMessage(messages.title)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 1
                  </label>
                  <MultiLanguageInput
                    baseField="checkInContentOne"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 2
                  </label>
                  <MultiLanguageInput
                    baseField="checkInContentTwo"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>
              </div>

              {/* Check-Out Section */}
              <div className={cx(s.sectionBox, cs.spaceTop4)}>
                <h3 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.spaceBottom3)}>
                  <FormattedMessage {...messages.checkOutSection} />
                </h3>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.adminTitleLabel} />
                  </label>
                  <MultiLanguageInput
                    baseField="checkOutTitle"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="text"
                    placeholder={formatMessage(messages.title)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 1
                  </label>
                  <MultiLanguageInput
                    baseField="checkOutContentOne"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>

                <FormGroup className={s.space3}>
                  <label className={cs.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} /> 2
                  </label>
                  <MultiLanguageInput
                    baseField="checkOutContentTwo"
                    values={formValues}
                    onChange={this.handleFieldChange}
                    inputType="textarea"
                    placeholder={formatMessage(messages.enterContent)}
                  />
                </FormGroup>
              </div>

              <FormGroup className={cx(s.noMargin, cs.spaceTop4)}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                    <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                      <FormattedMessage {...messages.save} />
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

CancellationPolicyForm = reduxForm({
  form: 'CancellationPolicyForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(CancellationPolicyForm);

const selector = formValueSelector('CancellationPolicyForm');

// Helper to generate field selectors for all languages
const getMultiLangFields = (state, baseFields) => {
  const result = {};
  const langs = ['', '_en', '_fr', '_it', '_pt'];
  baseFields.forEach(field => {
    langs.forEach(lang => {
      const fieldName = `${field}${lang}`;
      result[fieldName] = selector(state, fieldName);
    });
  });
  return result;
};

const baseFields = [
  'contentOne', 'contentTwo',
  'beforeDaysTitle', 'beforeDaysContentOne', 'beforeDaysContentTwo',
  'checkInTitle', 'checkInContentOne', 'checkInContentTwo',
  'checkOutTitle', 'checkOutContentOne', 'checkOutContentTwo'
];

const mapState = (state) => ({
  formValues: getMultiLangFields(state, baseFields)
});

const mapDispatch = { change };

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(CancellationPolicyForm)));
